import React from "react";
import "./Video1.css";
import demo from "../videos/Demo.mp4";
import demo1 from "../videos/Demo1.mp4";
import demo2 from "../videos/Demo2.mp4";

const Video1 = () => {
  return (
    <div className="video1">
      <div className="video1-contain">
        <video controls>
          <source src={demo} type="video/mp4" />
        </video>
        <p>Item Categorization</p>
        <p>1:52</p>
      </div>
      <div className="video1-contain">
        <video controls>
          <source src={demo1} type="video/mp4" />
        </video>
        <p>Stock Adjustments and Profit</p>
        <p>2:19</p>
      </div>
      <div className="video1-contain">
        <video controls>
          <source src={demo2} type="video/mp4" />
        </video>
        <p>Demo #3</p>
        <p>0:52</p>
      </div>
    </div>
  );
};

export default Video1;
